import { Component, Input, Output, EventEmitter } from '@angular/core';
import { InboundFax } from '../../../core/models/inbound-fax.model';
import { PdfFileType } from '../../../core/enums/pdf-file-type.enum';
import { SimilarInboundFaxState } from 'app/capture-admin/pages/capture-admin-inbound-fax/capture-admin-inbound-fax.component';
import { InboundFaxStatus } from '../../../core/enums/inbound-fax-status.enum';
import { InboundFaxAttributeChangeType, InboundFaxProcessFormComponent } from '../inbound-fax-process-form/inbound-fax-process-form.component';
import { InboundFaxHeaderComponent } from '../inbound-fax-header/inbound-fax-header.component';

import { InboundFaxViewOcrLlmProcessingComponent } from '../inbound-fax-view-ocr-llm-processing/inbound-fax-view-ocr-llm-processing.component';
import { InboundFaxViewProcessedComponent } from '../inbound-fax-view-processed/inbound-fax-view-processed.component';
import { InboundFaxPossiblePatientsComponent } from '../inbound-fax-possible-patients/inbound-fax-possible-patients.component';
import { PdfBasicViewerComponent } from '../../../shared/components/pdf-basic-viewer/pdf-basic-viewer.component';

@Component({
    selector: 'app-inbound-fax-main-tab',
    templateUrl: './inbound-fax-main-tab.component.html',
    styleUrls: ['./inbound-fax-main-tab.component.scss'],
    imports: [InboundFaxHeaderComponent,
              InboundFaxProcessFormComponent,
              InboundFaxViewOcrLlmProcessingComponent,
              InboundFaxViewProcessedComponent,
              InboundFaxPossiblePatientsComponent,
              PdfBasicViewerComponent]
})
export class InboundFaxMainTabComponent {
  pdfFileType: PdfFileType = PdfFileType.inboundFax;

  @Input() inboundFax: InboundFax;
  @Input() inboundFaxInitialState: InboundFax;

  @Input() similarInboundFaxState = new SimilarInboundFaxState();

  @Output() inboundFaxAttributeChanged = new EventEmitter<InboundFaxAttributeChangeType>;
  @Output() tabChangeRequested = new EventEmitter<string>;
  @Output() nextFaxRequested = new EventEmitter<void>;
  @Output() skipToNextFaxRequested = new EventEmitter<void>;
  @Output() navigateToQueueRequested = new EventEmitter<void>;

  onInboundFaxAttributeChange(type: InboundFaxAttributeChangeType) {
    this.inboundFaxAttributeChanged.emit(type);
  }

  onTabChangeRequested(newTab: string) {
    this.tabChangeRequested.emit(newTab);
  }

  onNextFaxRequested() {
    this.nextFaxRequested.emit();
  }

  onSkipToNextFaxRequested() {
    this.skipToNextFaxRequested.emit();
  }

  onNavigateToQueueRequested() {
    this.navigateToQueueRequested.emit();
  }

  onPdfUrlChange(url: string) {
    this.inboundFax.url = url;
  }

  get inOcrOrLlmProcessing() {
    return this.inboundFax.status === InboundFaxStatus.inOcr ||
      this.inboundFax.status === InboundFaxStatus.llmProcessing;
  }
}
